export { Subtitle2Stronger } from './Subtitle2Stronger';
export { subtitle2StrongerClassNames } from './useSubtitle2Stronger.styles';
